import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import helpers from 'helpers/helpers'

function Projections(props) {

	const [takedown_columns, setTakedownColumns] = useState([])
	const [columns, setColumns] = useState([])
	const [data, setData] = useState([])
	const [takedown_data, setTakedownData] = useState([])
	
	useEffect(() => {
		buildData('columns')
		buildDataTakedowns('columns')
	}, [])

	useEffect(() => {
		buildData('data')
		buildDataTakedowns('data')
	}, [columns, takedown_columns])

	useEffect(() => {
		buildData("columns")
		buildDataTakedowns("columns")
	}, [props.currentDates])

	const buildData = (buildData) => {
		let ret = []

		let columns = [
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Type",
				accessor: "Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Type"),
			},
		]
		let months = helpers.monthsBetween(props.currentDates.startStamp, props.currentDates.endStamp)
		let years = []
		_.forEach(months, (v) => {
			years.push(parseInt(v.year))
		})
		years = _.uniq(years)
		_.forEach(years, (v) => {
			columns.push({
				Header: v.toString(),
				columns: [],
			})
		})
		let store = {}
		columns.push({
			Header: "Total",
			accessor: "Total",
			filterable: false,
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.Total || 0
				})
				return total
			},
		})
		_.forEach(months, (v) => {
			let find = _.find(columns, { Header: v.year.toString() })
			find.columns.push({
				Header: v.month,
				accessor: `${v.year}-${v.month}`,
				width: 50,
				filterable: false,
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (r) => {
						total += r[`${v.year}-${v.month}`] || 0
					})
					return total
				},
			})
		})
		_.forEach(props.payload.exec.projections, (v) => {
			let rowTimes = {
				startStamp: moment(`${v.year}-${v.month}`, "YYYY-M").startOf("month").unix(),
				endStamp: moment(`${v.year}-${v.month}`, "YYYY-M").endOf("month").unix(),
				startMonth: moment(props.currentDates.start).month() + 1,
				endMonth: moment(props.currentDates.end).month() + 1,
				startYear: moment(props.currentDates.start).year(),
				endYear: moment(props.currentDates.end).year(),
			}
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let property = _.find(props.payload.public.properties, { id: type?.property })
			if (!years.includes(v.year) || !type || !property) {
				return
			} else if (
				(v.month == rowTimes.startMonth && v.year == rowTimes.startYear) ||
				(v.month == rowTimes.endMonth && v.year == rowTimes.endYear)
			) {
				// This is the start date or the end date, so add to the pile.
			} else if (
				rowTimes.startStamp < props.currentDates.startStamp ||
				rowTimes.endStamp > props.currentDates.endStamp
			) {
				return
			}
			let month = moment()
				.year(v.year)
				.month(v.month - 1)
				.startOf("month")
				.add(10, "days")
				.format("YYYY-MMM")
			let path = `${property.name}.${type.name}.${month}`
			if (!_.has(store, path)) {
				_.setWith(store, path, v.projection, Object)
			}
		})
		_.forEach(store, (propertyData, Community) => {
			_.forEach(propertyData, (buckets, Type) => {
				let Total = 0
				_.forEach(buckets, (r) => {
					Total += r
				})
				ret.push({
					Community,
					Type,
					...buckets,
					Total,
				})
			})
		})
		if(buildData == 'data') {
			setData(ret)
		}
		else if(buildData == 'columns') {
			setColumns(columns)
		}
	}

	const buildDataTakedowns = (buildData) => {
		let ret = []

		let columns = [
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Type",
				accessor: "Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Type"),
			},
		]
		let months = helpers.monthsBetween(props.currentDates.startStamp, props.currentDates.endStamp)
		let years = []
		_.forEach(months, (v) => {
			years.push(parseInt(v.year))
		})
		years = _.uniq(years)
		_.forEach(years, (v) => {
			columns.push({
				Header: v.toString(),
				columns: [],
			})
		})
		let store = {}
		columns.push({
			Header: "Total",
			accessor: "Total",
			filterable: false,
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.Total || 0
				})
				return total
			},
		})
		_.forEach(months, (v) => {
			let find = _.find(columns, { Header: v.year.toString() })
			find.columns.push({
				Header: v.month,
				accessor: `${v.year}-${v.month}`,
				width: 50,
				filterable: false,
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (r) => {
						total += r[`${v.year}-${v.month}`] || 0
					})
					return total
				},
			})
		})
		_.forEach(props.payload.exec.projections_takedowns, (v) => {
			let rowTimes = {
				startStamp: moment(`${v.year}-${v.month}`, "YYYY-M").startOf("month").unix(),
				endStamp: moment(`${v.year}-${v.month}`, "YYYY-M").endOf("month").unix(),
				startMonth: moment(props.currentDates.start).month() + 1,
				endMonth: moment(props.currentDates.end).month() + 1,
				startYear: moment(props.currentDates.start).year(),
				endYear: moment(props.currentDates.end).year(),
			}
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let property = _.find(props.payload.public.properties, { id: type.property })
			if (!years.includes(v.year) || !type || !property) {
				return
			} else if (
				(v.month == rowTimes.startMonth && v.year == rowTimes.startYear) ||
				(v.month == rowTimes.endMonth && v.year == rowTimes.endYear)
			) {
				// This is the start date or the end date, so add to the pile.
			} else if (
				rowTimes.startStamp < props.currentDates.startStamp ||
				rowTimes.endStamp > props.currentDates.endStamp
			) {
				return
			}
			let month = moment()
				.year(v.year)
				.month(v.month - 1)
				.startOf("month")
				.add(10, "days")
				.format("YYYY-MMM")
			let path = `${property.name}.${type.name}.${month}`
			if (!_.has(store, path)) {
				_.setWith(store, path, v.projection, Object)
			}
		})
		_.forEach(store, (propertyData, Community) => {
			_.forEach(propertyData, (buckets, Type) => {
				let Total = 0
				_.forEach(buckets, (r) => {
					Total += r
				})
				ret.push({
					Community,
					Type,
					...buckets,
					Total,
				})
			})
		})
		if (buildData == "data") {
			setTakedownData(ret)
		} else if (buildData == "columns") {
			setTakedownColumns(columns)
		}
	}
	if (!props.payloadStatus || !data || data.length == 0) {
		return (
			<div className="projections">
				<div className="imageGroup">
					<Title title="Projections" />
					<div className="content">
						<p>No data available.</p>
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div className="projections">
				<div className="imageGroup">
					<Title title="Projections" />
					<div className="content">
						<h2>Sales Projections</h2>
						<FullTable
							data={data}
							columns={columns}
							name="projections__sales"
							title="Projections"
						/>
						{props.payload.exec.projections_takedowns.length > 0 && (
							<>
								<h2>Takedown Projections</h2>
								<FullTable
									data={takedown_data}
									columns={takedown_columns}
									name="projections__takedown"
									title="Takedown Projections"
								/>
							</>
						)}
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Projections)
